import { render, staticRenderFns } from "./ManageAcademyClass.vue?vue&type=template&id=00250afc&scoped=true"
import script from "./ManageAcademyClass.vue?vue&type=script&lang=js"
export * from "./ManageAcademyClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00250afc",
  null
  
)

export default component.exports